import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/global.css';

/* PWA UI for Capacitor Plugins i.e. 'Camera' */
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { store } from '@/store';

store.loadState();

const app = createApp(App)
  .use(IonicVue, {
    // rippleEffect: false,
    mode: Capacitor.getPlatform() == 'android' ? 'md' : 'ios',
  })
  .use(router);
  
router.isReady().then(() => {
  app.mount('#app');
});

defineCustomElements(window);
